import {useTranslations} from 'next-intl';

const useTermsTabItems = () => {
  const t = useTranslations('terms');

  return [
    {
      text: t('tabLabel'),
      value: 'general-terms',
      child: true
    }
  ];
};

export default useTermsTabItems;
